import './send-again-dialog.component.css';

const sendAgainDialogConfig = {
    selector: 'mwSendAgainDialog',
    bindings: {
        distribution: '<',
        recipientLists: '<'
    },
    template: `
        <mw-mini-modal-dialog 
            class="mw-mini-modal-dialog mw-mini-modal--wide" 
            layout="column" 
            flex
            data="$ctrl.model" 
            title="{{'newsletters__modal-title--send-again'|translate}}" 
            ok="{{'Send'|translate}}" 
            cancel="{{'Cancel'|translate}}" 
            on-ok="$ctrl.handleOk($event)" 
            on-cancel="$ctrl.handleCancel($event)">
            
            <mw-modal-alert-message layout="column" ng-if="$ctrl.shouldValidateForm"> 
                {{'app__form-messaging--please-review'|translate}}
            </mw-modal-alert-message> 
            <mw-modal-content> 
                <ng-form name="$ctrl.sendAgainForm"> 
                    <div layout="column"> 
                        <md-input-container md-is-error="$ctrl.shouldValidateForm && !$ctrl.sendAgainForm.subjectLine.$valid"> 
                            <label translate>mw-newsletter-distribution-data-table__table-header--subject</label> 
                            <input name="subjectLine" ng-model="$ctrl.model.subjectLine" required="required" maxlength="80"/> 
                            <div class="maxCharCount" translate>newsletter-wizard-page__max-char--remaining-characters-label</div> 
                            <div class="maxCharCount" >: {{80 - $ctrl.model.subjectLine.length}}</div>
                            <div class="md-errors-spacer"></div> 
                            <div ng-messages="$ctrl.sendAgainForm.subjectLine.$error"> 
                                <div ng-message="required" translate>app__form-messaging--required-field</div> 
                            </div> 
                        </md-input-container>  
                        <md-input-container md-is-error="$ctrl.shouldValidateForm && !$ctrl.sendAgainForm.recipientList.$valid"> 
                            <label translate>mw-newsletter-data-table__column-header-list</label> 
                            <md-select name="recipientList" ng-model="$ctrl.model.recipientList" required="required">
                                <md-option ng-repeat="recipientList in $ctrl.recipientLists | orderBy: 'listName'" ng-value="recipientList._id">
                                    {{::recipientList.listName}}
                                </md-option>
                            </md-select>
                            <div class="md-errors-spacer"></div> 
                            <div ng-messages="$ctrl.sendAgainForm.recipientList.$error"> 
                                <div ng-message="required" translate>app__form-messaging--required-field</div> 
                            </div> 
                        </md-input-container> 
                    </div> 
                </ng-form> 
            </mw-modal-content> 
      </mw-mini-modal-dialog>
    `,
    controller: null
};

class SendAgainDialog {
    distribution: any;
    recipientLists: any[];
    model: any;
    sendAgainForm: any;
    shouldValidateForm: boolean;
    constructor(
        private $translate,
        private $mdDialog
    ) {
        'ngInject';
        this.model = {};
        this.shouldValidateForm = false;
    }

    $onInit() {
        this.model.subjectLine = this.distribution.newsletterSubject;
        this.model.recipientList = null;
    }

    handleOk() {
        if (this.sendAgainForm.$invalid) {
            this.shouldValidateForm = true;
        } else {
            this.$mdDialog.hide(this.model);
        }
    }

    handleCancel() {
        this.$mdDialog.cancel();
    }
}

sendAgainDialogConfig.controller = SendAgainDialog;

export {
    sendAgainDialogConfig,
    SendAgainDialog as default
}



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/newsletter-distributions/send-again-dialog/send-again-dialog.component.ts
 **/